export default __webpack_public_path__ + "static/media/stopwatch-timer.d01c6e04.svg";